import { hasAnyRole } from "../Utils/Common";

export const RoleBasedRender = ({ allowedRoles, children }) => {
  console.log("Role results", hasAnyRole(allowedRoles));
  return hasAnyRole(allowedRoles) ? children : null;
};
